import React, { useState } from "react";
import { GridActionsCellItem, useGridApiRef } from "@mui/x-data-grid-pro";
import DataGridComponent from "../Widgets/DataGridComponent";
import { useSelector } from "react-redux";
import { t } from "react-i18nify";
import { BasicTooltip } from "../Widgets/StyledComponents";
import { downloadFile } from "../../js/utils/backend";
import { dateTimeToString } from "../../js/utils/genericMethods";
import DownloadIcon from "@mui/icons-material/Download";
import PreviewIcon from "@mui/icons-material/Preview";
import { useParams } from "react-router-dom/cjs/react-router-dom";

/** CommentComponent */
const SharedDocumentsGrid = ({
    CategoryID,
    label,
    baseURL ,
    hideActionColumn = false,
    isSharedFilesGrid=true,
    ...props
}) => {
    const apiRef = useGridApiRef();
    const cellFocusField = "IGG";
    const userID = useSelector(state => state.auth.UserID);
    const token = useSelector(state => state.auth.Token);
    const currentEntity = useSelector(state => state.userPref.CurrentEntity);
    // eslint-disable-next-line
    const [visitedRow, setVisitedRow] = useState();
    const forceGridRefresh = useState(false);
    const { ID } = useParams();
    const { otEntityID } = useParams();


    const gridSpecificColumns = [
        {
            field: "CreationDate",
            headerName: t("field.CreatedOn"),
            width: 150,
            editable: false,
            valueFormatter: params =>
                dateTimeToString(params.value, "DateTime"),
        },
        {
            field: "Name",
            headerName: t("field.Name"),
            width: 200,
            editable: false,
        },
        {
            field: "Filename",
            headerName: t("field.Filename"),
            width: 150,
            flex: 1,
            editable: false,
        },
        {
            field: "Author",
            headerName: t("field.Author"),
            width: 100,
            editable: false,
        },
        {
            field: "MediaID",
            headerName: t("field.MediaID"),
        },
        {
            field: "OTEntityTreeID",
            headerName: t("field.OTEntitySelector"),
        },       
        {
            field: "DocumentID",
            headerName: t("field.DocumentID"),
        },
        
    ];
    
    const specificActionsColumns = (params, _editing, isLocalLoading) => [
        <>

            <GridActionsCellItem
                label="Preview file"
                icon={
                    <BasicTooltip title={`${t("common.PreviewFile")}`}>
                        <PreviewIcon />
                    </BasicTooltip>
                }
                onClick={() => {
                    downloadFile(
                        token,
                        "preview",
                        `/${params.row.MediaID}/${currentEntity.ObjectID}`
                    );
                }}
                disabled={_editing || isLocalLoading}
            />

            <GridActionsCellItem
                label="Preview file"
                icon={
                    <BasicTooltip title={`${t("common.PreviewFile")}`}>
                        <PreviewIcon />
                    </BasicTooltip>
                }
                onClick={() => {
                    downloadFile(
                        token,
                        "preview",
                        `/${params.row.MediaID}/${currentEntity.ObjectID}`
                    );
                }}
                disabled={_editing || isLocalLoading}
            />
            <GridActionsCellItem
                icon={
                <BasicTooltip
                    title={`${t("common.Download")}`}
                >
                    <DownloadIcon />
                </BasicTooltip>
            }
            onClick={() => {
                downloadFile(
                    token,
                   "download",
                    `/${params.row.MediaID}/${params.row.DocumentID}`
                );
            }}
                label={t("common.Add")}
                className="textPrimary"
                color="inherit"
                disabled={isLocalLoading}
            />         
        </>,
    ];


    return (
        <DataGridComponent
            apiRef={apiRef}
            baseURL={baseURL}
            cellFocusField={cellFocusField}
            label={label}
            gridSpecificColumns={gridSpecificColumns}
            initialState={{
                sorting: {
                    sortModel: [{ field: "CreationDate", sort: "asc" }],
                },
            }}
            columnVisibilityModel={{
                "MediaID": false,
                "OTEntityTreeID":false,
                "DocumentID":false
            }}
            paramURL={`UserId=${userID}&CategoryId=${ID}&OtEntityId=${otEntityID}`}
            //paramURL={`id=eccb1616-4c02-4300-b136-bba2a6e593a8`}
            forceGridRefresh={forceGridRefresh}
            isDeleteDisabled={true}
            isEditDisabled={true}
            specificActionsColumns={specificActionsColumns}
            visitedRow={visitedRow}
            hideActionColumn={hideActionColumn}
            {...props}
        />
    );
};



export default SharedDocumentsGrid;
